// ============================================================
//  TRADES — top-level taxonomy used by the estimate tool panel's
//  Calculators and Templates tabs. Only Landscaping is enabled
//  while we build out the category bundles. Other trades are
//  surfaced as locked options so the dropdown communicates the
//  product roadmap.
// ============================================================

export interface Trade {
  id: string;
  label: string;
  enabled: boolean;
}

export const TRADES: Trade[] = [
  { id: 'landscaping',         label: 'Landscaping',          enabled: true  },
  { id: 'general_contractor',  label: 'General Contractor',   enabled: false },
  { id: 'concrete',            label: 'Concrete',             enabled: true  },
  { id: 'roofing',             label: 'Roofing',              enabled: true  },
  { id: 'electrical',          label: 'Electrical',           enabled: true  },
  { id: 'plumbing',            label: 'Plumbing',             enabled: true  },
  { id: 'painting',            label: 'Painting',             enabled: true  },
  { id: 'hvac',                label: 'HVAC',                 enabled: true  },
  { id: 'cleaning',            label: 'Cleaning',             enabled: true  },
];

export const DEFAULT_TRADE_ID = 'landscaping';
